import React from 'react';
import JlptHero from '../components/jlpt/JlptHero/JlptHero';
import JlptPlacementTest from '../components/jlpt/JlptPlacementTest/JlptPlacementTest';

/**
 * JLPT page — hero with level pills and placement test.
 */
function JlptPage() {
  return (
    <main>
      <JlptHero />
      <JlptPlacementTest />
    </main>
  );
}

export default JlptPage;
